import { GridList } from '@sleepstation/components'
import { LAYOUT_SPACING, SIZE } from '@sleepstation/const'
import {
  backgroundImageLinearGradient,
  marginH,
  mq,
  paddingV,
  stylesIfPropTrue,
} from '@sleepstation/style-api-helpers'
import {
  constrainWide,
  defaultBorder,
  dropShadow,
} from '@sleepstation/style-mixins'
import { defaultTheme } from '@sleepstation/themes-public-site'
import { renderList } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { ThemeProvider, css } from 'styled-components'
import MenuItem from './MenuItem'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(GridList).attrs({
  'data-cy': `account-nav-dropdown-menu`,
  spacing: [
    0,
    LAYOUT_SPACING.MEDIUM,
    LAYOUT_SPACING.LARGE,
    [LAYOUT_SPACING.XX_LARGE, LAYOUT_SPACING.LARGE],
  ],
  columns: [1, 1, 2],
})`
  ${mq(`smallUp`)} {
    grid-auto-rows: 1fr;
  }

  ${mq(`xSmallOnly`)} {
    > * {
      ${defaultBorder(`bottom`)}
      ${marginH([-1])}
    }
  }
`

const MenuWrapper = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: -1;
  visibility: hidden;
  opacity: 0;
  will-change: opacity, transform, visibility;
  transform: translateY(95%);
  transition:
    visibility 0.25s,
    opacity 0.25s ease-in,
    transform 0.25s ease-in;

  ${paddingV([0, 2])}
  ${dropShadow(SIZE.LARGE)}

  ${backgroundImageLinearGradient()}

  /* stylelint-disable-next-line */
  > * {
    ${constrainWide()}
  }

  ${stylesIfPropTrue(
    `isSelected`,
    css`
      visibility: visible;
      opacity: 1;
      transform: translateY(100%);
      transition:
        visibility 0s,
        opacity 0.25s ease-out,
        transform 0.25s ease-out;
    `
  )}
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const PageNavDropdownMenu = ({ isSelected, setIsSelected, links }) => (
  <ThemeProvider theme={defaultTheme}>
    <MenuWrapper isSelected={isSelected}>
      <Layout>
        {renderList(
          ({ title, body, url, image, isHighlighted }) => (
            <MenuItem
              title={title}
              body={body}
              url={url}
              imageUrl={image}
              onClick={() => setIsSelected(false)}
              isHighlighted={isHighlighted}
            />
          ),
          links
        )}
      </Layout>
    </MenuWrapper>
  </ThemeProvider>
)

PageNavDropdownMenu.propTypes = {
  links: PropTypes.arrayOf(PropTypes.object).isRequired,
  isSelected: PropTypes.bool.isRequired,
  setIsSelected: PropTypes.func.isRequired,
}

export default PageNavDropdownMenu
